import { render } from "./ArrowButton.vue?vue&type=template&id=12004fda&scoped=true"
import script from "./ArrowButton.vue?vue&type=script&lang=js"
export * from "./ArrowButton.vue?vue&type=script&lang=js"

import "./ArrowButton.vue?vue&type=style&index=0&id=12004fda&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/booking-calendars/athletics-booking-calendar/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12004fda"]])

export default __exports__